// removed by extract-text-webpack-plugin
module.exports = {"same-product":"same-product","same-product-title":"same-product-title","wrap-same-product":"wrap-same-product","same-product-contailer":"same-product-contailer","product-wrap":"product-wrap","product":"product","price":"price"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/product/popup-view-detail/same-product/style.scss
// module id = ./components/partials/product/popup-view-detail/same-product/style.scss
// module chunks = 0